export default __webpack_public_path__ + "static/ring1-e6ed2db4929e27fa682d5cdce6b2cc09.png";